module.exports = __webpack_public_path__ + "img/45_37.6737eec4.png";